let config = {
  cors: 'socket.nevia-app.com:1212',
  api: 'socket.nevia-app.com:57679',
  apiAuth: 'socket.nevia-app.com:9290',
  fileApi: 'socket.nevia-app.com:9000',
  //api: '52dfffj6il.execute-api.eu-west-1.amazonaws.com/Teststage',
  socket: 'socket.nevia-app.com:57679',
  //socket: 'test.ec2.nevia-app.com:57679',
  road: 'socket.nevia-app.com:1212/https://avoinapi.vaylapilvi.fi/viitekehysmuunnin/muunna',
  road2: 'avoinapi.vaylapilvi.fi/viitekehysmuunnin'
}

export default config;
